import styled from 'styled-components';

const LightboxImageStyled = styled.div`
  .LightboxImage {
    &__controls {
      display: flex;
    }

    &__icon {
      width: 20px;
      height: 20px;
    }

    &__image {
    }
  }
`;

export { LightboxImageStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
